howspace.components.time = (() => {
    'use strict';

    const toLocale = time => {
        try {
            if (!time.attr('datetime')) {
                return;
            }
            const date = new Date(time.attr('datetime'));

            const options = {};

            if (time.data('show-date') !== false) {
                options.year = 'numeric';
                options.month = 'numeric';
                options.day  = 'numeric';
            }

            if (time.data('show-time') !== false) {
                options.hour = 'numeric';
                options.minute = 'numeric';
            }

            time.text(date.toLocaleString(real.locale.getLocaleAsBCP47(), options));
        } catch (e) {
            // Converting date to locale string failed. Leave the UI as is.
            console.log('Could not show', time.attr('datetime'), 'as locale string.', e);
        }
    };

    return {
        init: (elem) => {
            // Init times shown on display.
            elem.findIncludingSelf('.howspace-time:not(.howspace-time-initialized)').each(function () {
                const time = $(this);

                time.addClass('howspace-time-initialized');

                toLocale(time);
            });

            // Init times shown in tooltips.
            elem.findIncludingSelf('.howspace-time-tooltip:not(.howspace-time-tooltip-initialized)').each(function () {
                const timeTooltip = $(this);

                timeTooltip.addClass('howspace-time-tooltip-initialized');

                // Create a helper div element and put the tooltip content as its html.
                const helper = $('<div/>');
                helper.html(timeTooltip.data('title'));

                // Init all howspace time elements within the helper.
                howspace.components.time.init(helper);

                // Convert all howspace time elements inside the tooltip as plain text.
                helper.findIncludingSelf('.howspace-time.howspace-time-initialized').each(function() {
                    let time = $(this);
                    time.replaceWith(time.text());
                });

                // Update the tooltip title attribute.
                timeTooltip.dataAndAttr('title', helper.html());
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-time.howspace-time-initialized').each(function () {
                const time = $(this);
                time.removeClass('howspace-time-initialized');
            });

            elem.findIncludingSelf('.howspace-time-tooltip.howspace-time-tooltip-initialized').each(function () {
                const timeTooltip = $(this);
                timeTooltip.removeClass('howspace-time-tooltip-initialized');
            });
        }
    };

})();
